export const ID_KEYS = {
	BANNER: 'cookies-banner',
	CCPA_BANNER: 'ccpa-cookies-banner',
};

export const CSS_VARIABLE_NAMES = {
	BANNER_HEIGHT: '--cookies_banner_height',
};
